import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const ReportTable = ({ call, role }) => {
  let showRecs = { icon: '', path: '', target: '' };
  const { data, identificador, origem, origem_secundaria, destino, destino_secundario, fila, duracao, status, tipo, protocolo, aguardando } = call;  

  let url = window.location.href;
  url = url.split('/')[2];

  const date = new Date(data);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  const adminTd = <Link to={{ pathname: `http://${url}/api/download/file/${protocolo}` }} target="_blank"><FontAwesomeIcon icon={faPlay} fixedWidth /></Link>;
  const userTd = <FontAwesomeIcon icon={faBan} fixedWidth />;

  const dateBr = `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`;

  return (
    <tr className='is-size-7 has-text-centered '>
      <td>{`${dateBr} ${time}`}</td>
      <td>{identificador}</td>
      <td>{origem}</td>
      <td>{origem_secundaria}</td>
      <td>{destino}</td>
      <td>{destino_secundario}</td>
      <td>{fila}</td>
      <td>{aguardando}</td>
      <td>{duracao}</td>
      <td>{tipo}</td>
      <td>{status}</td>
      <td>{protocolo}</td>
      <td>{ role === 'user' || protocolo === '' ? userTd : adminTd }</td>
    </tr>
  )
}

ReportTable.propTypes = {
    data: PropTypes.string,
    origem: PropTypes.string,
    origem_secundaria: PropTypes.string,
    fila: PropTypes.string,
    destino: PropTypes.string,
    destino_primario: PropTypes.string,
    status: PropTypes.string,
    aguardando: PropTypes.string,
    duracao: PropTypes.string,
    tipo: PropTypes.string,
    id: PropTypes.string,
    protocolo: PropTypes.string,
  };

export default ReportTable;
